import { Message, MessageBox } from 'element-ui'

export default {
  // baseURL: "http://47.97.254.63:9500/prop/back",
  baseURL: '/prop/back',
  // baseURL: "http://127.0.0.1:9500/prop/back",
  successTip(text) {
    Message({
      message: text,
      type: 'success'
    })
  },
  errorTip(text) {
    Message({
      message: text,
      type: 'error'
    })
  },
  warningTip(text) {
    Message({
      message: text,
      type: 'warning'
    })
  },
  handleCurrentChange(val, that) {
    that.params.pageNo = val
    if ($('.right-height')) {
      $('.right-height').animate({ scrollTop: 0 }, 0)
    }
    if ($('.tableBoxAuto')) {
      $('.tableBoxAuto').animate({ scrollTop: 0 }, 0)
    }
    if (that.$refs.multipleTable) {
      that.$nextTick(() => {
        that.$refs.multipleTable.bodyWrapper.scrollTop = 0
      })
    }
    setTimeout(function() {
      that.getList()
    })
  },
  handleSizeChange(val, that) {
    that.params.pageSize = val
    that.getList()
    setTimeout(function() {
      $('.right-height').animate({ scrollTop: 0 }, 0)
      $('.tableBoxAuto').animate({ scrollTop: 0 }, 0)
    })
  },
  isNull(data) {
    return data === null || data === undefined || data === ''
  },
  pubConfirm(txt, callback) {
    MessageBox.confirm(txt, '', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      center: true,
      dangerouslyUseHTMLString: true
    })
      .then(() => {
        if (callback !== null && callback !== undefined && callback !== '') {
          callback('success')
        }
      })
      .catch(() => {})
  },
  getCheckedIds(data) {
    let ids = []
    data.forEach(function(item) {
      ids.push(item.id)
    })
    return ids.join(',')
  },
  tableDataPub(that, data) {
    that.tableData = data.data.records
    that.total = data.data.total
    that.currentPage = Number(that.params.pageNo)
    that.pageSizes = [50, 100, 200, 500, 800, 1000]
    if (Number(that.total) > 1000) {
      that.pageSizes.push(Number(that.total))
    }
  },
  getBtnPermissions(that) {
    setTimeout(function() {
      that.btnPermissions = localStorage.getItem('btnPermissions').split(',')
    })
  },
  provinceMap: {
    北京市: [116.41667, 39.91667],
    天津市: [117.2, 39.13333],
    河北省: [115.48333, 38.03333],
    山西省: [112.53333, 37.86667],
    内蒙古自治区: [111.670801, 41.818311],
    辽宁省: [123.38333, 41.8],
    吉林省: [125.35, 43.88333],
    黑龙江省: [127.63333, 47.75],
    上海市: [121.55333, 31.2],
    江苏省: [119.78333, 32.05],
    浙江省: [120.2, 30.26667],
    安徽省: [117.283042, 31.86119],
    福建省: [118.3, 26.08333],
    江西省: [115.9, 28.68333],
    山东省: [117.000923, 36.675807],
    海南省: [110.35, 20.01667],
    湖北省: [114.298572, 30.584355],
    湖南省: [113.0, 28.21667],
    广东省: [113.23333, 23.16667],
    广西壮族自治区: [108.320004, 22.82402],
    河南省: [113.65, 34.76667],
    重庆市: [106.45, 29.56667],
    四川省: [104.06667, 30.66667],
    贵州省: [106.71667, 26.56667],
    云南省: [102.73333, 25.05],
    西藏自治区: [91.0, 30.6],
    陕西省: [108.95, 34.26667],
    甘肃省: [103.73333, 36.03333],
    青海省: [96.75, 36.56667],
    宁夏回族自治区: [106.26667, 37.46667],
    新疆维吾尔自治区: [87.68333, 43.76667],
    台湾省: [121.3, 25.03],
    香港: [114.1, 22.2],
    澳门: [113.5, 22.2]
  },
  setPermissionUrl(that, menuData, type, routeUrl) {
    let permissionUrl = []
    menuData.forEach(function(item) {
      if (item.hasOwnProperty('url') && !that.commonApi.isNull(item.url)) {
        permissionUrl.push(item.url)
      }
      item.childMenus.forEach(function(item2) {
        if (item2.hasOwnProperty('url') && !that.commonApi.isNull(item2.url)) {
          permissionUrl.push(item2.url)
        }
        item2.childMenus.forEach(function(item3) {
          if (item3.hasOwnProperty('url') && !that.commonApi.isNull(item3.url)) {
            permissionUrl.push(item3.url)
          }
          if (item3.url === that.$route.path) {
            // that.routePath==item2.url
          }
        })
        if (type === '按钮权限') {
          if ((that.commonApi.isNull(routeUrl) && item2.authorization === that.$route.name) || (!that.commonApi.isNull(routeUrl) && item2.authorization === routeUrl)) {
            item2.btnPermissionsName = []
            item2.childMenus.forEach(function(item3) {
              item2.btnPermissionsName.push(item3.name)
            })
            localStorage.setItem('btnPermissions', item2.btnPermissionsName.join(','))
          }
        }
      })
    })
    localStorage.setItem('permissionUrl', JSON.stringify(permissionUrl))
    if (menuData.length > 0) {
      if (menuData[0].childMenus.length === 0) {
        localStorage.setItem('IndexPage', menuData[0].url)
        if (type === '跳转') {
          that.$router.push({ path: menuData[0].url })
        }
      } else {
        localStorage.setItem('IndexPage', menuData[0].childMenus[0].url)
        if (type === '跳转') {
          that.$router.push({
            path: menuData[0].childMenus[0].url
          })
        }
      }
    }
  },
  // areaData:["海曙区","江北区","北仑区","镇海区","鄞州区","象山县","宁海县","余姚市","慈溪市","奉化区","高新区"],
  areaData: [],
  setPcaa(that) {
    for (var i in that.pcaa[86]) {
      if (that.pcaa[86][i] !== '浙江省') {
        delete that.pcaa[86][i]
      }
    }
    that.pcaa[330200][330283] = '奉化区'
    that.pcaa[330200][330284] = '高新区'
    that.pcaaShow = true
  },
  getStreetItem(that, data) {
    that.districtList = []
    data.forEach(function(item) {
      item.district = that.commonApi.isNull(item.district) ? '' : item.district
      if (that.districtList.indexOf(item.district) < 0) {
        that.districtList.push(item.district)
      }
    })
    let arrs = []
    that.districtList.forEach(function(item2) {
      let obj = { name: item2, arr: [], children: [] }
      data.forEach(function(item) {
        if (item.district === item2 && obj.arr.indexOf(item.street) < 0) {
          obj.arr.push(item.street)
          obj.children.push({ name: item.street })
        }
      })
      arrs.push(obj)
    })
    data.forEach(function(item) {
      item.district = that.commonApi.isNull(item.district) ? '' : item.district
      arrs.forEach(function(item2) {
        item2.children.forEach(function(item3) {
          item3.childrens = that.commonApi.isNull(item3.childrens) ? [] : item3.childrens
          if (item.district === item2.name && item.street === item3.name) {
            item3.childrens.push(item)
          }
        })
      })
    })
    return arrs
  },
  streetSearch(that, data, val) {
    let arr = []
    let activeName = []
    let Index = 0
    data.forEach(function(item) {
      let obj = { name: item.name, arr: [], children: [] }
      item.children.forEach(function(item2) {
        if (item2.name.indexOf(val) >= 0) {
          obj.arr.push(item2.name)
          obj.children.push(item2)
        }
      })
      if (obj.arr.length > 0) {
        arr.push(obj)
        activeName.push(Index)
        Index++
      }
    })
    if (!that.commonApi.isNull(val)) {
      that.activeName = activeName
    }
    return arr
  },
  checkNo: 0
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js